import { useMemo } from 'react';
import {
  createResourceCacheMapAtom,
  createSingleCacheEntryAtom,
  createResourceAtom,
} from 'lib/atoms';
import { TransactionPartyResponse } from 'types/api-responses';
import { ReconcilerResult, ReconcilerDefaultsResponse } from './types';

const reconcilerResultsAtom = createResourceCacheMapAtom<ReconcilerResult>();

export const useReconcilerAtom = (
  entityId: number,
  documentId: number,
  validationId?: string | null,
  overlapThreshold?: number,
  tolerance?: number,
  shapeMatchThreshold?: number
) =>
  useMemo(() => {
    let url = `/title_validator/reconciler?entity_id=${entityId}&document_id=${documentId}`;
    if (validationId) {
      url += `&validation_id=${validationId}`;
    }
    if (overlapThreshold !== undefined) {
      url += `&overlap_threshold=${overlapThreshold}`;
    }
    if (tolerance !== undefined) {
      url += `&tolerance=${tolerance}`;
    }
    if (shapeMatchThreshold !== undefined) {
      url += `&shape_match_threshold=${shapeMatchThreshold}`;
    }
    return createSingleCacheEntryAtom(reconcilerResultsAtom)(url);
  }, [
    entityId,
    documentId,
    validationId,
    overlapThreshold,
    tolerance,
    shapeMatchThreshold,
  ]);

export const useTransactionPartiesAtom = (documentId: number | null) => {
  const href = documentId
    ? `/documents/${documentId}/transaction_parties`
    : undefined;
  return useMemo(
    () => createResourceAtom<TransactionPartyResponse[]>(href),
    [href]
  );
};

export const useReconcilerDefaultsAtom = (href: string | undefined) =>
  useMemo(() => createResourceAtom<ReconcilerDefaultsResponse>(href), [href]);
